"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ObserverSet = void 0;
const notifier_1 = require("./notifier");
class ObserverSet {
    constructor(name) {
        this.name = name;
        this.immediateObservers = null;
        this.latentObservers = null;
    }
    [Symbol.iterator]() {
        var _a, _b;
        return (_b = (_a = this.latentObservers) === null || _a === void 0 ? void 0 : _a[Symbol.iterator]()) !== null && _b !== void 0 ? _b : ObserverSet.EMPTY_ITERATOR;
    }
    addObserver(observer, options) {
        var _a, _b;
        if (options === null || options === void 0 ? void 0 : options.immediate) {
            ((_a = this.immediateObservers) !== null && _a !== void 0 ? _a : (this.immediateObservers = new Set())).add(observer);
            return;
        }
        ((_b = this.latentObservers) !== null && _b !== void 0 ? _b : (this.latentObservers = new Set())).add(observer);
    }
    removeObserver(observer) {
        var _a;
        (_a = this.latentObservers) === null || _a === void 0 ? void 0 : _a.delete(observer);
    }
    notify() {
        var _a;
        (_a = this.immediateObservers) === null || _a === void 0 ? void 0 : _a.forEach(observer => observer());
        ObserverSet.NOTIFIER.enqueue(this);
    }
}
exports.ObserverSet = ObserverSet;
ObserverSet.EMPTY_ITERATOR = {
    next: () => ({ done: true, value: undefined }),
};
ObserverSet.NOTIFIER = new notifier_1.Notifier();
//# sourceMappingURL=observer-set.js.map